export const faqs = [
  {
    question: {
      en: 'How long does a typical concrete project take?',
      es: '¿Cuánto tiempo tarda un proyecto de concreto típico?',
    },
    answer: {
      en: "Most residential projects take 3-7 days depending on size and complexity. We'll provide an exact timeline in your estimate.",
      es: 'La mayoría de los proyectos residenciales tardan 3-7 días según el tamaño y la complejidad. Proporcionaremos un cronograma exacto en tu estimado.',
    },
  },
  {
    question: { en: 'Do you offer a warranty on your work?', es: '¿Ofrecen garantía en su trabajo?' },
    answer: {
      en: 'Yes, we stand behind all our work and offer customer satisfaction guarantee on every project.',
      es: 'Sí, respaldamos todo nuestro trabajo y ofrecemos garantía de satisfacción del cliente en cada proyecto.',
    },
  },
  {
    question: { en: 'Can you work with my contractor or engineer?', es: '¿Pueden trabajar con mi contratista o ingeniero?' },
    answer: {
      en: 'Absolutely. We work with contractors, engineers, and architects regularly and professionally.',
      es: 'Absolutamente. Trabajamos regularmente con contratistas, ingenieros y arquitectos de manera profesional.',
    },
  },
  {
    question: { en: 'What areas do you serve?', es: '¿Qué áreas atienden?' },
    answer: {
      en: 'We serve Chicagoland and surrounding suburbs including Cook County, DuPage County, and Will County. Contact us to confirm your area.',
      es: 'Servimos Chicagoland y alrededores incluyendo los condados de Cook, DuPage y Will. Contáctanos para confirmar tu área.',
    },
  },
  {
    question: { en: 'How much does a project cost?', es: '¿Cuánto cuesta un proyecto?' },
    answer: {
      en: 'Costs vary based on project size and scope. We provide free, detailed estimates with no obligation.',
      es: 'Los costos varían según el tamaño y alcance del proyecto. Proporcionamos estimados gratuitos y detallados sin obligación.',
    },
  },
  {
    question: { en: 'How do I get started?', es: '¿Cómo empiezo?' },
    answer: {
      en: "Call us at +1 (708) 632-0587 or fill out our free estimate form online. We'll contact you within 24 hours.",
      es: 'Llámanos al +1 (708) 632-0587 o completa nuestro formulario de estimado gratuito en línea. Nos contactaremos dentro de 24 horas.',
    },
  },
  {
    question: { en: 'Do you provide payment plans?', es: '¿Ofrecen planes de pago?' },
    answer: {
      en: 'Yes, we offer flexible payment options. Discuss payment plans during your free consultation.',
      es: 'Sí, ofrecemos opciones de pago flexibles. Discute planes de pago durante tu consulta gratuita.',
    },
  },
  {
    question: { en: "What if I'm not satisfied with the work?", es: '¿Qué pasa si no estoy satisfecho con el trabajo?' },
    answer: {
      en: "Your satisfaction is guaranteed. We'll address any concerns immediately and make it right.",
      es: 'Tu satisfacción está garantizada. Abordaremos cualquier preocupación inmediatamente y lo arreglaremos.',
    },
  },
];
